<div id="wrapper">
  <app-loading-screen></app-loading-screen>
  <div>
    <app-menu></app-menu>
  </div>
  <!--
  <div>
    <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
      (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
      (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
      (updateInitializeData)="this.initializeData()"></app-tab-nav>
  </div>
  <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
  -->
  <div class="allcont logsize">
    <div class="basicrow m-top">
      <div class="container">
        <div class="basicrow">
          <div class="fulltitle m-top-i titulo f-btitle autodef">
            <span class="icon-dash-14"></span>Políticas
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow mbott-politics-b margin-top-politics">
      <div class="container">
        <div class="basicrow m-top-i">
            <div class="difftabs">
            <div routerLink="/politics/1" (click)="this.statusChange(1);" [className]="this.selTab===1 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Política de Privacidad
            </div>
            <div routerLink="/politics/2" (click)="this.statusChange(2);" [className]="this.selTab===2 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Política de Pagos
            </div>
            <div routerLink="/politics/3" (click)="this.statusChange(3);" [className]="this.selTab===3 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
              Términos de Uso
            </div>
          </div>
        </div>
        <div id="politica-de-privacidad" class="basicrow m-top-ii" [ngStyle]="{'display':this.selTab === 1 ? 'block' : 'none' }">
            <!--Espacio para politica de privacidad-->
            <app-politica-privacidad></app-politica-privacidad>
            </div>
            <div id="politica-de-pagos" class="basicrow m-top-ii" [ngStyle]="{'display':this.selTab === 2 ? 'block' : 'none' }">
            <!--Espacio para politica de pago-->
            <app-politica-pago></app-politica-pago>
            </div>
            <div id="terminos-de-uso" class="basicrow m-top-ii" [ngStyle]="{'display':this.selTab === 3 ? 'block' : 'none' }">
            <!--Espacio para terminos de uso-->
            <app-terminos-uso></app-terminos-uso>
            </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>